import { Helmet } from 'react-helmet-async';

interface NotFoundSchemaProps {
  requestedUrl?: string;
  siteName?: string;
}

export const NotFoundSchema = ({ 
  requestedUrl,
  siteName = "SeniorThrive"
}: NotFoundSchemaProps) => {
  const notFoundSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Page Not Found",
    "description": "The requested page could not be found.",
    "url": requestedUrl || typeof window !== 'undefined' ? window.location.href : '',
    "mainEntity": {
      "@type": "Thing",
      "name": "404 Error",
      "description": "The requested resource is not available"
    },
    "isPartOf": {
      "@type": "WebSite",
      "name": siteName,
      "url": "https://seniorthrive.com"
    }
  };

  return (
    <Helmet>
      <title>Page Not Found - SeniorThrive</title>
      <meta name="description" content="The page you're looking for doesn't exist. Explore our resources for seniors, families, and caregivers." />
      <meta name="robots" content="noindex,nofollow" />
      <script type="application/ld+json">
        {JSON.stringify(notFoundSchema)}
      </script>
    </Helmet>
  );
};